<template>
  <button
    type="button"
    class="btn btn-link btn-sm text-white"
    @click="onClickAdd"
  >
    <i class="bi bi-justify-left" />
  </button>
</template>

<script setup>
import ModalWindow from '@/components/history/modal.vue'
import { useApi } from '@/composables/api'
import { useModalStack } from '@/stores/modalstack'
import { useUserStore } from '@/stores/user'
import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { format } from 'date-fns'

const { push: openModal } = useModalStack()
const { t } = useI18n()
const service = ref('rtms')
const page = ref(1)
const onPage = ref(20)
const dateFrom = ref(null)
const dateTo = ref(null)
const authors = ref([])

const query = computed(() => {
  const q = {
    service: service.value,
    page: page.value,
    onPage: onPage.value,
  }
  if (dateFrom.value) {
    q.date_from = format(new Date(dateFrom.value), 'yyyy-MM-dd')
  }
  if (dateTo.value) {
    q.date_to = format(new Date(dateTo.value), 'yyyy-MM-dd')
  }
  if (authors.value.length) {
    q.authors = [...authors.value]
  }
  return q
})

const { model: histModel, refresh, pending: loading } = useApi({
  url: 'audit_trail',
  data: {},
  query,
})

const modalRef = ref()
const userStore = useUserStore()

const options = computed(() => {
  const base = [
    { value: 'rtms', label: 'RTMS' },
    { value: 'catalogs', label: 'CATALOGS' },
    { value: 'all', label: t('history.ui.allServices') },
  ]
  if (userStore.can('sa')) {
    base.splice(2, 0, { value: 'sso', label: 'SSO' })
  }
  return base
})

async function onQueryChange(params) {
  if (params.page != null) page.value = params.page
  if (params.onPage != null) onPage.value = Number(params.onPage)
  if ('dateFrom' in params) dateFrom.value = params.dateFrom
  if ('dateTo' in params) dateTo.value = params.dateTo
  if ('authors' in params) authors.value = params.authors || []
  await refresh()
}

function resetQuery() {
  page.value = 1
  dateFrom.value = null
  dateTo.value = null
  authors.value = []
}

async function onClickAdd() {
  openModal({
    component: ModalWindow,
    componentRef: modalRef,
    props: {
      modelName: 'audit_trail',
      modelId: 0,
      headerText: 'Audit Trail',
      list: histModel,
      loading,
      options: options.value,
      auditTrailService: service,
      onQueryChange,
      serviceSelectCallback: async selected => {
        service.value = selected
        resetQuery()
        await refresh()
        modalRef.value?.listRef?.resetFilters?.({ emitQuery: false })
      },
    },
  })

  service.value = 'rtms'
  resetQuery()
  await refresh()
}
</script>
